import { Button } from 'antd';
import styled from 'styles/styled-components';

export const MainButton = styled(Button)`
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #ffffff;
  padding: 20px 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: #43a047;
  &:hover {
    background: #6fc373 !important;
    color: #ffffff !important;
  }
  &:active {
    background: #3c9041 !important;
    color: #ffffff !important;
  }
  ${({ fullWidth }) =>
    fullWidth &&
    `
      width: 100%;
    `}
`;

export const SecondaryButton = styled(Button)`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #43a047;
  padding: 20px 16px;
  display: flex;
  align-item: center;
  gap: 6px;
  border-color: #43a047;
  &:hover {
    background: #f0f9f1 !important;
  }
  &:active {
    border-color: #3c9041 !important;
    color: #3c9041 !important;
  }
  ${({ fullWidth }) =>
    fullWidth &&
    `
    width: 100%;
  `}
`;
